module.exports = __webpack_public_path__ + "img/a4.41c17cb8.png";